// Author lgq
// Date 2022-06-28 15:34:25

class EmSicCustomizedDiagramPieceCdp {
constructor({
        id = null,
        cdpIdDiagram = '',
        diagramName = '',
        cdpPieceCode = '',
        cdpName = '',
        cdpDataFormat = '',
        cdpViewType = '',
        cdpViewModel = '',
        cdpIdRelated = '',
        cdpProperties = '',
        cdpParamConf = '',
        remark = ''}
= {}) {
    this.id = id;
    this.cdpIdDiagram = cdpIdDiagram;
    this.diagramName = diagramName;
    this.cdpPieceCode = cdpPieceCode;
    this.cdpName = cdpName;
    this.cdpDataFormat = cdpDataFormat;
    this.cdpViewType = cdpViewType;
    this.cdpViewModel = cdpViewModel;
    this.cdpIdRelated = cdpIdRelated;
    this.cdpProperties = cdpProperties;
    this.cdpParamConf = cdpParamConf;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicCustomizedDiagramPieceCdp();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'diagramName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.diagramName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cdpPieceCode',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpPieceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cdpName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cdpDataFormat',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpDataFormat',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '名称' },
                            { value: '2', text: '计算属性名' },
                            { value: '3', text: '计算属性值' },
                            { value: '4', text: '计算属性名&值' },
                            { value: '5', text: '设备定制图' },
                            { value: '6', text: 'SQL' },
                            { value: '7', text: 'API' },
                            { value: '8', text: '页面跳转' }
            ]
        }
        },
        {
        key: 'cdpViewType',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpViewType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '直显' },
                            { value: '2', text: '悬浮' },
                            { value: '3', text: '跳转' },
                            { value: '4', text: '弹出框' }
            ]
        }
        },
        {
        key: 'cdpViewModel',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpViewModel',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '默认' },
                            { value: '2', text: '表格' },
                            { value: '3', text: '折线图' }
            ]
        }
        },
        {
        key: 'cdpProperties',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpProperties',
        sortable: true,
        form: {
        type: 'json-params',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cdpParamConf',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.cdpParamConf',
        sortable: true,
        form: {
        type: 'json',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    cdpIdDiagramFilter : '',
    diagramNameFilter : '',
    cdpPieceCodeFilter : '',
    cdpNameFilter : '',
    cdpDataFormatFilter : '',
    cdpViewTypeFilter : '',
    cdpViewModelFilter : '',
    cdpIdRelatedFilter : '',
    cdpPropertiesFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'diagramNameFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.diagramName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSicCustomizedDiagramScd'
            ,correspondingField: 'scdName'
            ,fieldsBindingByEntityModalSelected: '{"cdpIdDiagram":"id"}'
                }
        },
        {
        key: 'cdpPieceCodeFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpPieceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cdpNameFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cdpDataFormatFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpDataFormat',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '名称' },
                { value: '2', text: '计算属性名' },
                { value: '3', text: '计算属性值' },
                { value: '4', text: '计算属性名&值' },
                { value: '5', text: '设备定制图' },
                { value: '6', text: 'SQL' },
                { value: '7', text: 'API' },
                { value: '8', text: '页面跳转' }
            ]
        }
        },
        {
        key: 'cdpViewTypeFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpViewType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '直显' },
                { value: '2', text: '悬浮' },
                { value: '3', text: '跳转' },
                { value: '4', text: '弹出框' }
            ]
        }
        },
        {
        key: 'cdpViewModelFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpViewModel',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '默认' },
                { value: '2', text: '表格' },
                { value: '3', text: '折线图' }
            ]
        }
        },
        {
        key: 'cdpIdRelatedFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpIdRelated',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cdpPropertiesFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.filter.cdpProperties',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'diagramName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.diagramName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSicCustomizedDiagramScd'
            ,correspondingField: 'scdName'
            ,fieldsBindingByEntityModalSelected: '{"cdpIdDiagram":"id"}'
                }
        },
        {
        key: 'cdpPieceCode',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpPieceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'cdpName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cdpDataFormat',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpDataFormat',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '名称' },
                { value: '2', text: '计算属性名' },
                { value: '3', text: '计算属性值' },
                { value: '4', text: '计算属性名&值' },
                { value: '5', text: '设备定制图' },
                { value: '6', text: 'SQL' },
                { value: '7', text: 'API' },
                { value: '8', text: '页面跳转' }
            ]
        }
        },
        {
        key: 'cdpViewType',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpViewType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '直显' },
                { value: '2', text: '悬浮' },
                { value: '3', text: '跳转' },
                { value: '4', text: '弹出框' }
            ]
        }
        },
        {
        key: 'cdpViewModel',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpViewModel',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '默认' },
                { value: '2', text: '表格' },
                { value: '3', text: '折线图' }
            ]
        }
        },
        {
        key: 'cdpIdRelated',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpIdRelated',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cdpProperties',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.cdpProperties',
        sortable: true,
        disabled: false,
        form: {
        type: 'json-params',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicCustomizedDiagramPieceCdp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmSicCustomizedDiagramPieceCdp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
